import styles from "./Forbidden.module.css";

function Forbidden() {
  return <main className={styles.main}>Forbidden</main>;
}

export default Forbidden;
